<template>
  <nav aria-label="Progress">
    <ol role="list" class="overflow-hidden">
      <li class="left-4 top-4 mt-0.5 mb-4 w-0.5 font-bold text-xl leading-6">Registreren</li>
      <li
        v-for="(step, stepIdx) in steps"
        :key="step.name"
        class="relative"
        :class="{ 'pb-20': stepIdx !== steps.length - 1 }"
      >
        <div
          v-if="stepIdx !== steps.length - 1"
          class="absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5"
          :class="step.status === 'complete' ? 'bg-pdsPrimaryColor' : 'bg-gray-300'"
          aria-hidden="true"
        />
        <a
          :href="step.href"
          @click="$emit('exchange', stepIdx)"
          class="group relative flex items-start"
          :aria-current="step.status === 'current' ? 'step' : null"
        >
          <span class="flex h-9 items-center">
            <span
              class="relative z-10 flex size-8 items-center justify-center rounded-full"
              :class="stepClasses(step.status)"
            >
              <CheckIcon v-if="step.status === 'complete'" class="size-5 text-white" aria-hidden="true" />
              <span v-else-if="step.status === 'current'" class="size-2.5 rounded-full bg-pdsPrimaryColor" />
            </span>
          </span>
          <span class="ml-4 flex min-w-0 flex-col">
            <span class="font-semibold text-left" :class="textClasses(step.status)">{{ step.name }}</span>
          </span>
        </a>
      </li>
    </ol>
  </nav>
</template>

<script>
import { CheckIcon } from '@heroicons/vue/20/solid';
import { ref, watch, getCurrentInstance } from 'vue';

export default {
  name: 'AccountRegistrationProgressBar',
  components: { CheckIcon },
  props: {
    stepCompleted: {
      type: Number,
      required: true
    }
  },
  emits: ['navigate'],
  setup(props) {
    const $emitter = getCurrentInstance().appContext.config.globalProperties.$emitter;

    const navigate = (step) => {
      $emitter.emit('navigate', step);
    };

    const steps = ref([
      { name: 'Uit het register', href: '#', status: 'current' },
      { name: 'Contactgegevens', href: '#', status: 'upcoming' },
      { name: 'Organisaties & afdelingen', href: '#', status: 'upcoming' },
      { name: 'Rol & behandelgebieden', href: '#', status: 'upcoming' }
    ]);
    watch(
      () => props.stepCompleted,
      (newVal) => {
        steps.value = steps.value.map((step, index) => ({
          ...step,
          status: index < newVal ? 'complete' : index === newVal ? 'current' : 'upcoming'
        }));
      },
      { immediate: true }
    );
    const stepClasses = (status) => ({
      'bg-pdsPrimaryColor group-hover:bg-pdsPrimaryColor': status === 'complete',
      'border-2 border-bg-pdsPrimaryColor bg-white': status === 'current',
      'border-2 border-gray-300 bg-white group-hover:border-gray-400': status === 'upcoming'
    });

    const textClasses = (status) => ({
      'text-bg-pdsPrimaryColor': status === 'current',
      'text-gray-300': status === 'upcoming'
    });

    return { steps, stepClasses, textClasses, props, navigate };
  }
};
</script>
